import { Component } from 'react';

/**
 * ErrorBoundary — catches React render errors so the whole UI doesn't go blank.
 * Usage:
 *   <ErrorBoundary name="VoucherEngine">
 *     <YourComponent />
 *   </ErrorBoundary>
 */
export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error(`[ErrorBoundary:${this.props.name || 'unknown'}]`, error, info);
        // Future: send to a logging service here
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    padding: '24px', margin: '16px', borderRadius: '8px',
                    background: '#fef2f2', border: '1px solid #fca5a5',
                    fontFamily: 'sans-serif'
                }}>
                    <div style={{ fontWeight: 'bold', color: '#dc2626', marginBottom: '8px' }}>
                        ⚠ An error occurred in {this.props.name || 'Component'}
                    </div>
                    <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '12px' }}>
                        {this.state.error?.message || 'Unknown error'}
                    </div>
                    <button
                        onClick={() => this.setState({ hasError: false, error: null })}
                        style={{
                            padding: '6px 14px', background: '#dc2626', color: 'white',
                            border: 'none', borderRadius: '4px', cursor: 'pointer',
                            fontSize: '13px', fontWeight: 'bold'
                        }}
                    >
                        Retry
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}
